import http from './_http'

const ip = {
  add: (m) => http.post(`api/v3/ip`, m),
  get: (id) => http.get(`api/v3/ip/${id}`),
  list: (m) => http.post(`api/v3/ip/search`, m),
  update: (m) => http.put(`api/v3/ip`, m),
  delete: (id) => http.delete(`api/v3/ip/${id}`),
}
export default ip